import { render, staticRenderFns } from "./PulmotilMedicationReportForm.vue?vue&type=template&id=5cd31bef&scoped=true&"
import script from "./PulmotilMedicationReportForm.vue?vue&type=script&lang=ts&"
export * from "./PulmotilMedicationReportForm.vue?vue&type=script&lang=ts&"
import style0 from "./PulmotilMedicationReportForm.vue?vue&type=style&index=0&id=5cd31bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd31bef",
  null
  
)

export default component.exports